module.exports = __webpack_public_path__ + "static/media/in.e4ab7bd0.svg";